import React, { useEffect, useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/ButtonGroup';
import styles from "assets/jss/material-kit-react/components/admin/adminStyle.js";
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Axios from "axios";
import Config from "../../../../config.js"
import swal from 'sweetalert'
import BeatLoader from "react-spinners/BeatLoader";
import Pagination from "material-ui-flat-pagination";
const useStyles = makeStyles(styles);


export default function History(props) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  let [loading, setLoading] = useState(true);
  
  useEffect(() => {
    setLoading(true)
    Axios.post(Config.api + "Extra/GetContactUs", {
      Limit: limit,
      Offset: offset
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        setLoading(false)
        setRows(result.data.data)
        setTotal(result.data.data?.count||0)
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }, [limit,offset])

  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root + " " + classes.box} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.div}>
                <Typography variant="h6" gutterBottom>
                  {props.title ? props.title : "لیست ارتباط با ما"}
                </Typography>
                
                <TableContainer className={classes.tableContainer} >
                  <div className={classes.center + " " + classes.fastAccess}>
                    <BeatLoader loading={loading} color={"gray"} size={15} />
                  </div>
                  {!loading ? (
                    <Table className={classes.table} aria-label="caption table">
                      <TableHead>
                        <TableRow>
                          <TableCell >نام و نام خانوادگی</TableCell>
                          <TableCell >ایمیل</TableCell>
                          <TableCell >شماره موبایل</TableCell>
                          <TableCell >متن</TableCell>
                          <TableCell >تاریخ</TableCell>
                        </TableRow>

                      </TableHead>
                      <TableBody>
                        {rows?.result?.map((row) => (
                          <TableRow>
                            <TableCell component="th" scope="row" >
                              {row.name}
                            </TableCell>
                            <TableCell component="th" scope="row" >
                              {row.email}
                            </TableCell>
                            <TableCell>{row.mobile}</TableCell>
                            <TableCell>{row.text}</TableCell>
                            <TableCell>{new Date(row.createAt).toLocaleDateString('fa-IR')+" "+new Date(row.createAt).toLocaleTimeString('fa-IR')}</TableCell>
                             </TableRow>
                             
                        ))}

                      </TableBody>
                    </Table>
                  ) :
                    null}
                </TableContainer>
                <br />
                <Pagination
          limit={10}
          className={classes.center}
          offset={offset}
          total={total}
          onClick={(e, offset) => setOffset(offset)}
        />
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </form>
  );
}